module.exports = __webpack_public_path__ + "img/Chevron-Down_16px_Icon-Light.b4514a66.svg";